var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment2Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440,1040c-75,0-140-25-195-80c-55-55-80-120-80-195V240c0-55,20-100,60-140c40-40,85-60,140-60s100,20,140,60s60,85,60,140 v400h-75V240c0-35-10-65-35-90s-55-35-90-35c-35,0-65,10-90,35s-35,55-35,90v525c0,55,20,100,60,140c40,40,85,60,140,60 c25,0,45-5,70-10c20-10,40-20,55-35v90c-20,10-40,15-60,20C485,1040,465,1040,440,1040z M665,840H565c-15,0-25-5-35-15 c-10-10-15-20-15-35s5-25,15-35c10-10,20-15,35-15h100V640c0-15,5-25,15-35s20-15,35-15s25,5,35,15s15,20,15,35v100h100 c15,0,25,5,35,15c10,10,15,20,15,35s-5,25-15,35c-10,10-20,15-35,15H765v100c0,15-5,25-15,35c-10,10-20,15-35,15s-25-5-35-15 c-10-10-15-20-15-35L665,840z M440,765v75c-35,0-65-10-90-35s-35-55-35-90V280c0-10,5-20,10-25c5-5,15-10,25-10c10,0,20,5,25,10 c5,5,10,15,10,25v440c0,15,5,25,15,35C415,765,425,765,440,765z M640,490V280c0-10,5-20,10-25c5-5,15-10,25-10c10,0,20,5,25,10 c5,5,10,15,10,25v210H640z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment2Black);
export default __webpack_public_path__ + "static/media/attachment-2-black.a3d269682f9d39aa1eeb6d807cc069d2.svg";
export { ForwardRef as ReactComponent };